export default {"src":"/_next/static/media/logo-spotify.3900cfa0.svg","height":2931,"width":2931,"blurWidth":0,"blurHeight":0};